import routeMap from "../router_map";

export default {
  path: "/set",
  meta: {
    title: "设置",
    icon: "lollipop",
    rank: 12
  },
  children: [
    {
      path: "/set/user/index",
      name: "SetUser",
      meta: {
        title: "账户信息"
      }
    },
    {
      path: "/set/safeSet/safeSet",
      name: "safeSet",
      meta: {
        title: "安全设置",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/set/safeSet/safeSet"],
    {
      path: "/set/message/notice",
      name: "SetMessageNotice",
      meta: {
        title: "消息通知",
        visible: "0",
        operate: "0"
      }
    },
    {
      path: "/set/operate/index",
      name: "SetOperate",
      meta: {
        title: "操作员管理",
        visible: "0",
        operate: "0"
      }
    },
    {
      path: "/set/operate/create",
      name: "SetOperateCreate",
      meta: {
        title: "新增用户",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/set/operate/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/set/operate/detail",
      name: "SetOperateDetail",
      meta: {
        title: "管理员详情",
        showLink: false,
        hiddenTag: true,
        matchedPath: "/set/operate/index",
        visible: "1",
        operate: "0"
      }
    }
  ]
};
